import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { RestValidateProjectNameResponse } from './types.tsx';

export const constructEndpoint = (projectName: string) =>
	`/rest/simplified/latest/project/validate?projectName=${encodeURIComponent(projectName)}`;

export const get = (
	projectKey: string,
	abortSignal?: AbortSignal,
): Promise<RestValidateProjectNameResponse> => {
	const url = constructEndpoint(projectKey);
	return performGetRequest(url, { signal: abortSignal });
};
